import { type FindingDetail } from '@/features/state/lib/findingView'

/** The Detail cell. A tagged union from findingView keeps the per-category branching out of the
 *  table body and out of the pure module that computes it. */
export function DetailCell({ detail }: { detail: FindingDetail }) {
  if (detail.kind === 'ports') {
    return <span style={{ fontFamily: 'var(--mono)', fontSize: '0.75rem' }}>{detail.ports.join(', ') || '-'}</span>
  }
  if (detail.kind === 'endpoint') {
    return (
      <span style={{ fontFamily: 'var(--mono)', fontSize: '0.75rem', color: 'var(--text)' }}>
        {detail.address}
        {detail.isPrivate && <span className="badge badge-neutral" style={{ marginLeft: 6, fontSize: '0.6rem' }}>private</span>}
        {detail.resolvedIp && (
          <span style={{ fontSize: '0.65rem', color: 'var(--text3)', marginLeft: 6 }}>&rarr; {detail.resolvedIp}</span>
        )}
        {detail.unresolved && (
          <span className="badge badge-neutral" style={{ marginLeft: 6, fontSize: '0.6rem', color: 'var(--amber)' }}>unresolved</span>
        )}
      </span>
    )
  }
  // Clamped: a future misconfiguration `description` is prose, not an attribute key, and would
  // otherwise wrap a paragraph into a narrow mono cell.
  return (
    <span
      title={detail.value ?? undefined}
      style={{ display: 'inline-block', fontFamily: 'var(--mono)', fontSize: '0.75rem', color: 'var(--text3)', maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'bottom' }}
    >
      {detail.value ?? '-'}
    </span>
  )
}
